import { z } from "zod";
import { AddressSchema } from "./address.schema";
import { PhoneNumberSchema } from "./phone.schema";

// Schemas

export const ContactInfoSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  salutation: z.string(),
  primaryAddress: AddressSchema,
  primaryPhone: PhoneNumberSchema.or(PhoneNumberSchema.array()),
});
